module.exports = __webpack_public_path__ + "static/media/picking-up-reaching-down-svgrepo-com.139e7c6b.svg";